import React from "react";
import { Box, Flex, Icon, IconButton, Text, Tooltip, useColorModeValue } from "@chakra-ui/react";
import { MdRefresh, MdAssessment } from "react-icons/md";

/**
 * Header bar for the ElasticStatusCard with title badge and refresh button.
 * @param {object} props
 * @param {boolean} props.loading - Whether data is being fetched
 * @param {Function} props.onRefresh - Callback triggered on refresh click
 * @returns {React.ReactElement}
 */
function StatusHeader({ loading, onRefresh }) {
    const badgeBg = useColorModeValue("brand.100", "whiteAlpha.100");
    const titleColor = useColorModeValue("secondaryGray.900", "white");
    return (
        <Flex align="center" justify="space-between" mb="16px">
            <Flex align="center" gap="12px">
                <Flex align="center" justify="center" w="44px" h="44px" borderRadius="12px" bg={badgeBg}>
                    <Icon as={MdAssessment} w="24px" h="24px" color="brand.500" />
                </Flex>
                <Box>
                    <Text fontSize="lg" fontWeight="700" color={titleColor}>ElasticSearch Status</Text>
                </Box>
            </Flex>
            <Tooltip label="Refresh" placement="top" hasArrow>
                <IconButton aria-label="Refresh status" icon={<Icon as={MdRefresh} />}
                    onClick={onRefresh} isLoading={loading} variant="ghost" size="sm" />
            </Tooltip>
        </Flex>
    );
}

export default StatusHeader;
